
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay'

export function Carousel() {
    const [emblaRef] = useEmblaCarousel({
        breakpoints: {
            768: {
                duration: 1000,
                loop: true,
            },
        },
        watchResize: true,
        loop: true,
    }, [Autoplay()])

    const slides = [
        {
            image: '/images/mo5_1.jpg',
        },
        {
            image: '/images/mo5_2.jpg',
        },
        {
            image: '/images/mo5_3.jpg',
        },
        {
            image: '/images/mo5_4.jpg',
        },
        {
            image: '/images/mo5_5.jpg',
        },
        {
            image: '/images/mo5_6.jpg',
        },
        {
            image: '/images/mo5_7.jpg',
        },

    ]
    return (
        <div className="h-[12rem]">
            <div className="cover-image overflow-hidden mx-4 h-[10rem]">
                <div className="embla mx-4 min-h-[10rem]" ref={emblaRef}>
                    <div className="embla__container cover-image">
                        {slides.map((slide, index) => (
                            <div className="embla__slide" key={index}>
                                <img src={slide.image} alt={`MO5 ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}